// This file was copied from site scanner. Planned to move it to ui-common
export const getBaseURL = (): string => {
	const { protocol, hostname, port } = window.location;
	const portPart = port ? `:${port}` : '';
	return `${protocol}//${hostname}${portPart}`;
};
